module.exports = __webpack_public_path__ + "a9ba41032e08286dabb7185fa43744c1.svg";